export class SubmitKey {
    constructor() {
        this.clear();
    }
    clear() {
        this.blendShader = this.other = 0;
    }
}
